<db-dialog-wrapper [dialog]="this" [width]="'700px'" [height]="'626px'">
  <div class="db-enable-2fa" dbCustomScrollbar>
    <div class="db-enable-2fa-wrap" *ngIf="!_2faCreated">
      <div class="db-enable-2fa-header">
        <div class="db-enable-2fa-title">{{'text_enable2faTitle' | dbText}}</div>
        <div class="db-enable-2fa-desc" [innerHTML]="'text_enable2faDesc' | dbText: {code: _2faSecret}"></div>
      </div>
      <div class="db-enable-2fa-body">
        <div class="db-enable-2fa-qr-image"><img *ngIf="qrCodeImage" [src]="qrCodeImage"/></div>
        <div class="db-enable-2fa-qr-image-desc">{{'text_enable2faImageDesc' | dbText}}</div>
      </div>
      <div class="db-enable-2fa-footer">
        <div class="db-enable-2fa-auth-code">
          <div class="db-enable-2fa-auth-code-title">Authentication code</div>
          <div class="db-enable-2fa-auth-code-input">
            <form [formGroup]="_2faForm" (keydown)="keyDownFunction($event)">
              <input formControlName="_2faCode" class="db-fc-input _2fa-code"
                     [style.border-color]="(_2faForm.controls?._2faCode.invalid && formSubmitted) || (serverErrors && serverErrors.fields['2fa_token']) ? '#E95E5B' : null"/>
            </form>
            <div class="db-server-error-wrap">
              <div *ngIf="!hasServerFieldErrors && ((_2faForm.controls['_2faCode'].invalid && ((_2faForm.controls['_2faCode'].touched && !_2faForm.controls['_2faCode'].errors['required']) || formSubmitted))  ||  (serverErrors && serverErrors.fields._2faCode))">{{'text_empty2fa' | dbText}}</div>
              <div *ngIf="hasServerFieldErrors && ((_2faForm.controls['_2faCode'].invalid && ((_2faForm.controls['_2faCode'].touched && !_2faForm.controls['_2faCode'].errors['required']) || formSubmitted))  ||  (serverErrors && serverErrors.fields['2fa_token']))">{{serverErrors && serverErrors.fields['2fa_token'] && serverErrors.fields['2fa_token'][0]}}</div>
              <div *ngIf="!hasServerFieldErrors && (_2faForm.controls['_2faCode'].invalid && ((_2faForm.controls['_2faCode'].touched && !_2faForm.controls['_2faCode'].errors['required']) || formSubmitted))  ||  (serverErrors && !serverErrors.fields['2fa_token'])">{{serverErrors && serverErrors.message}}</div>
            </div>
          </div>
        </div>
        <div class="db-enable-2fa-button">
          <a class="ds-btn-m ds-btn-blue" (click)="enable2fa()">
            <span *ngIf="!loading">Enable</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="_2faCreated" class="db-enabled-2fa-wrap">
      <div class="db-enable-2fa-header">
        <div class="db-enabled-2fa-title">{{'text_enabled2faTitle' | dbText}}</div>
      </div>
      <div class="db-enabled-2fa-body">
        <div class="db-enabled-2fa-body-title"></div>
        <div class="db-enabled-2fa-body-desc">{{'text_enable2faImageDesc' | dbText}}</div>
        <div class="db-enabled-2fa-body-codes" *ngIf="recoveryCodes && recoveryCodes.length">
          <div *ngFor="let recoveryCode of recoveryCodes" class="db-enabled-2fa-body-code-item">{{recoveryCode}}</div>
        </div>
        <a class="db-button db-button_sm" ngxClipboard [cbContent]="recoveryCodesForCopy" (cbOnSuccess)="copiedCodes()"
           *ngIf="!isCopiedCodes">
          <span>{{'text_copy' | dbText}}</span>
        </a>
        <a *ngIf="isCopiedCodes" class="db-button db-button_sm">
          <span>{{'text_copied' | dbText}}</span>
        </a>
      </div>
      <div class="db-enabled-2fa-footer">
        <div class="db-enabled-2fa-info"><i class="db-icon db-icon-info-lined"></i><div class="db-enable-2fa-info-text">Your recovery code is as important as your password! Keep it secret, keep it safe.</div></div>
        <div class="db-enabled-2fa-button">
        </div>
      </div>
    </div>
  </div>
</db-dialog-wrapper>
